import React, { useState, Fragment, useRef } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { privateAxios } from "../utils/axios";
import toast from "react-hot-toast";

function EditProduct({
  product,
  editProductModalSetting,
  handlePageUpdate,
}) {
  const [formData, setFormData] = useState({
    name: product.name || "",
    // price: product.price || "",
    description: product.description || "",
    // category: product.category || "",
    // description: product.description || "",
    // price: product.price || "",
    // unit: product.unit || "",
    // warranty: {
    //   duration: "0",
    //   unit: "days",
    // },
  });
 const [errors, setErrors] = useState({});
  const [error, setError] = useState("");

  const [success, setSuccess] = useState("");
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const queryClient = useQueryClient();

  // Input refs for keyboard navigation
  const nameRef = useRef();
  const descriptionRef = useRef();

  const editProductMutation = useMutation({
    mutationFn: async (updatedData) => {
      const response = await privateAxios.put(
        `/products/edit/${product._id}`,
        updatedData
      );
      return response.data;
    },
    onSuccess: (data) => {
      toast.success("Updated successfully!");
      setError("");
      setTimeout(() => {
        queryClient.invalidateQueries(["products"]);
        handlePageUpdate();
        editProductModalSetting();
      }, 1000);
    },
    onError: (error) => {
      setError(error.response?.data?.message || "Failed to update");
      setSuccess("");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
 
    if (
      !formData.name 
    ) {
      setError("Please fill in all required fields");
      return;
    }

    // Create update data object with required fields
    const updateData = {
      name: formData.name,
      price: formData.price,
      description: formData.description,
      // phone: formData.phone,
      // address: formData.address,
    };
   console.log(updateData)
    // Only add optional fields if they have values
    // if (formData.email?.trim()) {
    //   updateData.email = formData.email;
    // }
    // if (formData.phone2?.trim()) {
    //   updateData.phone2 = formData.phone2;
    // }

     editProductMutation.mutate(updateData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-60 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-2xl transition-all sm:my-8 sm:w-full sm:max-w-xl border border-gray-100">
                {/* Close button */}
                <button
                  type="button"
                  className="absolute right-4 top-4 text-gray-400 hover:text-gray-500"
                  onClick={() => editProductModalSetting()}
                >
                  <span className="sr-only">Close</span>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>

                <div className="bg-gradient-to-b from-white to-gray-50 px-6 pt-6 pb-4 sm:p-6">
                  <div className="w-full">
                    <Dialog.Title
                      as="h3"
                      className="text-2xl font-semibold text-gray-900 mb-6 pb-2 border-b border-gray-100"
                    >
                      Edit Product
                    </Dialog.Title>

                    {error && (
                      <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
                        {error}
                      </div>
                    )}

                    {success && (
                      <div className="mb-4 p-3 bg-green-100 text-green-700 rounded-md">
                        {success}
                      </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-4">
                      <div>
                        <label
                          htmlFor="name"
                          className="block mb-2 text-sm font-medium text-gray-700"
                        >
                           Name *
                        </label>
                        <input
                          ref={nameRef}
                          type="text"
                          name="name"
                          id="name"
                          value={formData.name}
                          onChange={handleChange}
                          // onKeyDown={(e) => handleKeyDown(e, "name")}
                          className="bg-white border-2 border-gray-300 focus:border-blue-500 focus:ring-blue-200 text-gray-900 text-sm rounded-lg block w-full p-3 placeholder-gray-400 transition-all duration-150 shadow-sm focus:ring-2 outline-none"
                          required
                        />
                      </div>
                            <div>
                          <label
                            htmlFor="description"
                            className="block mb-2 text-sm font-medium text-gray-700"
                          >
                            Description (Optional)
                          </label>
                          <textarea
                            ref={descriptionRef}
                            id="description"
                            rows="3"
                            name="description"
                            className="bg-white border-2 border-gray-300 focus:border-blue-500 focus:ring-blue-200 text-gray-900 text-sm rounded-lg block w-full p-3 placeholder-gray-400 transition-all duration-150 shadow-sm focus:ring-2 outline-none"
                            placeholder="Ex. High-quality engine oil filter suitable for all types of motor vehicles. Ensures efficient filtration of engine oil."
                            value={product.description}
                            onChange={handleChange}
                          />

                        </div>
                    </form>
                  </div>
                </div>
                <div className="bg-gray-50 px-6 py-4 sm:flex sm:flex-row-reverse sm:px-6 rounded-b-2xl border-t border-gray-100">
                  <button
                    type="button"
                    className={`inline-flex w-full justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto transition-all duration-150 ${
                      editProductMutation.isLoading
                        ? "opacity-60 cursor-not-allowed"
                        : ""
                    }`}
                    onClick={handleSubmit}
                    disabled={editProductMutation.isLoading}
                  >
                    {editProductMutation.isLoading ? (
                      <span className="flex items-center justify-center">
                        <svg
                          className="animate-spin h-5 w-5 mr-2 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8z"
                          ></path>
                        </svg>
                        Updating...
                      </span>
                    ) : (
                      "Update Product"
                    )}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto transition-all duration-150"
                    onClick={() => editProductModalSetting()}
                    ref={cancelButtonRef}
                    disabled={editProductMutation.isLoading}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default EditProduct;
